import createRoute from '@widesk-ui/tools/createRoute';
import PlaceModel  from '@models/website/PlaceModel';

const route = createRoute.splitView(
	'/website_entertainments/:websiteEntertainmentId/places',
	'website',
	'PlaceSplitView',
	PlaceModel.localize('plural'),
);
export default route;
